import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';
import DetailInfoElement from '../../components/DetailInfoItem';
import PopupConfirm from '../../components/PopupConfirm';
import Toolbar from '../../components/Toolbar';
import { formatMoney, formatDate, featureInDevelopment } from '../../utils';
import autoPaymentStore, { AutoPaymentStore } from 'src/stores/AutoPaymentStore';
import Policy from '../../models/Policy';

interface ConfirmRegisterAutoPaymentProps {
  store: AutoPaymentStore;
}


const ConfirmRegisterAutoPaymentObserver = observer(
  ({ store }: ConfirmRegisterAutoPaymentProps) => {
    const [t] = useTranslation();
    const history = useHistory();

    const _handleClose = () => {
      history.push('/');
    };

    const _handleBack = () => {
      history.goBack();
    };

    const [detail, setDetail] = useState<Policy>({});
    const [visibleModal, setVisibleModal] = useState(false);
    const [agreeTerm, setAgreeTerm] = useState(false);
    const [readMore, setReadMore] = useState(false);

    const [timeOutId, setTimeOutId] = useState(null);
    useEffect(() => {
      setDetail(history?.location?.state?.['detail'] ?? {} as Policy);
    }, [history.location.state, t]);

    const _handleConfirm = () => {
      if (!detail) return;
      setVisibleModal(false);
      store.registerAutoDebit(
        {
          phName: detail?.policyHolderName,
          policyNumber: detail?.policyNum,
        },
      ).then(
        (data: any) => {
          const templateData = {
            cif: data.cif,
            requestType: data.requestType,
            merchant: {
              code: 'MBAL',
              name: 'Bảo hiểm Nhân thọ MB Ageas Life',
            },
            autoDebitId: data.autoDebitId,
            amount: data.amount,
            description: 'Đăng ký thanh toán tự động BH định kỳ',
            frequencyUnit: null,
            schedulerPattern: null,
            dayOfAutoDebit: null,
            contractCode: data.contractCode,
            successMessage: 'Đăng ký thanh toán tự động thành công',
            metadata: '',
            paymentTransactionType: {
              name: 'Thanh toán Phí bảo hiểm định kỳ',
              code: 'TTBHDK',
              allowCard: true,
              allowBNPL: false,
            },
            autoDebitStatus: data.autoDebitStatus,
            billerCustomerId: data.billerCustomerId,
            billerCustomerCode: data.billerCustomerId,
            createdDate: data.createdDate,
            requestId: data.requestId,
            payment: {
              firstPaymentAmount: null,
              firstPaymentDescription: null,
              paymentTransactionStatus: null,
            },
            autoDebitType: data.autoDebitType,
            retryDay: null,
            recordId: null,
          };
          try {
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'PAYMENT_HUB_AUTODEBIT',
                  data: templateData,
                }),
              );
            }
          }catch (e) {
            featureInDevelopment()
          }
        },
      );
    };

    const showConfirmPopUp = () => {
      if (!agreeTerm) return;
      setVisibleModal(true);
    };


    return (
      <>
        <div className="screen-container ct-view bg-background fix-scroll">
          <Toolbar
            title={t('title_confirm_register_auto_payment')}
            showClose={true}
            onClose={_handleClose}
            onBack={_handleBack}
            titleKlass={'px-7'}
          />

          <div className="show-detail p-3">
            <div
              className={
                'show-detail-top border border-line border-radius-bottom mb-4 p-4 bg-white rounded'
              }
            >
              <div className={'mb-6 font-bold'}>
                {t('msg_confirm_register_auto_payment')}
              </div>
              <DetailInfoElement
                title={t('policy_number')}
                content={detail.policyNum}
              />
              <DetailInfoElement
                title={t('main_product_name')}
                content={detail.productName}
              />
              <DetailInfoElement
                title={t('policy_start_date_1')}
                content={formatDate(detail?.polStatrtDat)}
              />
              <DetailInfoElement
                title={t('pay_frequency')}
                content={detail.payFrequency}
              />
              <DetailInfoElement title={t('fee_frequency')} content={
                detail?.periodicPremium && detail?.currency ?
                  formatMoney(detail.periodicPremium)
                  + ' '
                  + detail?.currency
                  : null
              } />

              <div className="pt-4 px-2">
                <div className="mb-4">

                  {/*<span>*/}
                  {/*{t('agree_msg_1')}{' '}*/}
                  {/*  <div*/}
                  {/*    className={'text-blue-600'}*/}
                  {/*  >*/}
                  {/*    {t('agree_msg_2')}*/}
                  {/*  </div>*/}
                  {/*  .*/}
                  {/*</span>*/}
                  <Checkbox
                    // text={t('agree_term')}
                    textComponent={
                      <>
                        <div>
                          {/*Tôi xác nhận thông tin Hợp đồng Bảo hiểm  và đồng ý Thanh toán tự động trên Hợp đồng này {' '}*/}
                          Tôi đã đọc, hiểu và đồng ý với các cam kết thanh toán tự động trên hợp đồng này:{' '}
                          {!readMore && <span className={"text-blue-600 underline"} onClick={() => setReadMore(true)}>Xem thêm</span>}
                          {readMore && <ul>
                            <li>
                              - Các thông tin trên là hoàn toàn chính xác, được cung cấp nhằm mục đích thực hiện các
                              dịch vụ quy định tại Đề nghị này. Tôi/Chúng tôi hoàn toàn chịu trách nhiệm về các thông
                              tin cung cấp cho MB và cam kết kịp thời thông báo cho MB khi có bất kỳ thông tin nào được
                              thay đổi.
                            </li>
                            <li>
                              - Đã có đủ thời gian để nghiên cứu kỹ giấy đề nghị kiêm hợp đồng này.
                            </li>
                            <li>
                              - Đồng ý ủy quyền cho MB tự động trích tiền từ TKTT/Thẻ của Tôi/Chúng tôi tại MB sang tài
                              khoản thụ hưởng như Tôi/ Chúng tôi đã đề nghị với MB theo Quy định Dịch vụ đặt lệnh chuyển
                              tiền tự động đính kèm Đề nghị kiêm Hợp đồng này và chịu mọi trách nhiệm trước pháp luật về
                              việc ủy quyền này.
                            </li>
                            <li>
                              - Hợp đồng này sẽ chính thức có hiệu lực khi HSYCBH của Tôi/chúng tôi được chấp thuận phát
                              hành bởi MB Ageas Life. Trong trường hợp HSYCBH của Tôi/chúng tôi bị từ chối phát hành bởi
                              MB Ageas Life, Tôi/chúng tôi hiểu rằng, Hợp đồng này sẽ bị vô hiệu đối với HSYCBH đó. Hợp
                              đồng này tự động có hiệu lực hoặc vô hiệu theo hai trường hợp nêu trên mà không cần bất kỳ
                              thông báo bằng văn bản xác nhận nào khác của MB.
                            </li>
                            <li>
                              - Chi tiết về Quy định Dịch vụ đặt lệnh chuyển tiền tự động, vui lòng truy cập
                              Website
                              {' '}
                              <span
                                onClick={() => {
                                  const el = document.createElement('textarea');
                                  el.value = 'www.mbageas.life';
                                  document.body.appendChild(el);
                                  el.select();
                                  document.execCommand('copy');
                                  document.body.removeChild(el);
                                }}
                              >www.mbageas.life</span> {' '}
                              / Đóng phí bảo hiểm / Hướng dẫn đóng phí bảo hiểm.
                            </li>
                          </ul>}
                          {readMore && <span className={"text-blue-600 underline"} onClick={() => setReadMore(false)}>Rút gọn</span>}
                        </div>
                      </>
                    }
                    checked={agreeTerm}
                    onCheck={() => setAgreeTerm(!agreeTerm)}
                    type="individual"
                  />
                </div>
              </div>
              <div className={'border-t pt-3 bg-white '}>
                <Button
                  disabled={!agreeTerm}
                  text={t('confirm')}
                  extraClassName={'w-full'}
                  onClick={() => showConfirmPopUp()}
                />
              </div>
            </div>

            <PopupConfirm
              showIcon={false}
              isHtmlContent={true}
              content={`<strong className={'text-base'}>${t(
                'register_auto_payment',
              )}</strong>`}
              visible={visibleModal}
              cancelTitle={t('cancel_action')}
              onCancel={() => setVisibleModal(false)}
              onOk={() => _handleConfirm()}
            />
          </div>
        </div>
      </>
    );
  },
);

const ConfirmRegisterAutoPayment = () => <ConfirmRegisterAutoPaymentObserver store={autoPaymentStore} />;
export default ConfirmRegisterAutoPayment;
